<template>
    <v-row>
        <v-col cols=12 md="6" class="d-flex" v-for="member in members" :key="member.id">
            <member-data :member="member"/>
        </v-col>
        <v-col cols="12">
            <v-pagination
                v-if="pageCount > 1"
                v-model="page"
                :length="pageCount"
                :total-visible="7"
            />
        </v-col>
        <v-overlay :value="loading">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
    </v-row>
</template>

<script>
    import MemberData from '@/components/MemberData'
    import memberService from '@/services/admin/member-service'

    export default {
        components: { MemberData },
        data: () => {
            return {
                pageCount: 0,
                members: null,
                page: 1,
                loading: false
            }
        },
        computed: {
            dealer() {
                return this.$store.getters.getDealer
            }
        },
        watch: {
            page() {
                this.getMembers()
            }
        },
        created() {
            this.getMembers()
        },
        methods: {
            getMembers() {
                this.loading = true
                let filters = {}
                if (this.dealer) {
                    filters.dealer = this.dealer
                }
                memberService.getMembersByFilter(this.page, filters, null, null).then(resp => {
                    this.members = resp.data
                    this.pageCount = resp.last_page
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            }
        }
    }
</script>
